var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-wrapper"},[_c(_setup.FooterElemInPC),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-record"},[_c('span',{staticClass:"s2"},[_vm._v(" ©版权所有 浙江春风动力股份有限公司 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("春风动力中文官网 浙ICP备09098699号")])])])
}]

export { render, staticRenderFns }